// extracted by mini-css-extract-plugin
module.exports = {"partner-container":"Partner_partner-container__1xRSF","image":"Partner_image__2mjJA"};